// extracted by mini-css-extract-plugin
export default {"tooltip":"jQ-z","arrow":"kQ-z"};